
import startApp from "../../entry";
import informationPage from "./information.vue";

startApp(informationPage);
